import produce from "immer";

const initialState = {
  consultsByPatient: {},
  roster: {
    loading: false,
    specialists: [],
    summary: null,
  },
  requestInFlight: false,
};

export default produce((draft, action) => {
  if (typeof draft === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case "SET_PATIENT_CONSULTS":
      draft.consultsByPatient[action.payload.patientId] =
        action.payload.consults;
      break;
    case "SET_SPECIALIST_ROSTER":
      draft.roster.loading = action.payload.loading ?? false;
      draft.roster.specialists = action.payload.specialists ?? [];
      draft.roster.summary = action.payload.summary ?? null;
      break;
    case "CLEAR_SPECIALIST_ROSTER":
      draft.roster = initialState.roster;
      break;
    case "SET_SPECIALTY_REQUEST_IN_FLIGHT":
      draft.requestInFlight = !!action.payload;
      break;
    default:
  }
});
